import { Boss } from './Boss';
import Phaser from 'phaser';

export class BasicBoss extends Boss {
  private originalSpeed: number;
  private speedBoostActive: boolean = false;
  private speedBoostDuration: number = 3000; // 3 seconds

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.health = 300;
    this.maxHealth = 300;
    this.speed = 25;
    this.originalSpeed = this.speed;
    this.reward = 150;
    this.specialAbility = 'Speed Boost';

    // Visual representation - large boss
    const circle = scene.add.circle(0, 0, 20, 0xff0000);
    circle.setName('bossCircle');
    this.add(circle);
  }

  override activateAbility(): void {
    if (!this.speedBoostActive) {
      this.speedBoostActive = true;
      this.speed = this.originalSpeed * 2; // Double speed

      // Visual effect
      this.showAbilityEffect(0xffff00);

      // Reset after duration
      this.scene.time.delayedCall(this.speedBoostDuration, () => {
        this.speed = this.originalSpeed;
        this.speedBoostActive = false;
      });
    }
  }

  override takeDamage(amount: number): void {
    super.takeDamage(amount);
    const _this = this;
    // Visual feedback - change color temporarily
    const originalColor = 0xff0000;
    const flashColor = 0xffffff;

    // Find the circle visual and change its color
    const circle = this.getByName('bossCircle');
    if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(flashColor);
      circle.fillCircle(0, 0, 20);

      // Restore original color after 200ms
      this.scene.time.delayedCall(200, () => {
        if (!_this.speedBoostActive) {
          circle.clear();
          circle.fillStyle(originalColor);
          circle.fillCircle(0, 0, 20);
        }
      });
    } else if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(flashColor);
      circle.clearFX();
      this.scene.time.delayedCall(200, () => {
        if (!_this.speedBoostActive) {
          circle.setFillStyle(originalColor);
          circle.clearFX();
        }
      });
    }
  }
} 